import { userReducer } from "./user/user.reducer";

export const storeObject = {
  user:userReducer
}
